module.exports = new __parcel__URL__("user_stars.9007dbd9.svg").toString();